import React from 'react'
import PropTypes from 'prop-types'
import { AramGodInfo } from '../Screens/AramGod/main.js'

const AramGodPage = ({ data }) => {
  return <AramGodInfo data={data} />
}

AramGodPage.propTypes = {
  data: PropTypes.object.isRequired
}

export default AramGodPage
